// @mui
import { styled } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { Typography, Container, Stack, Card, Grid } from '@mui/material';
import MuiButton from '@mui/material/Button';
import { LoadingButton } from '@mui/lab';
// components
import Page from '../../components/Page';
import Message from '../../components/Message';
import instance from '../../api/axiosRequest';

// ----------------------------------------------------------------------

const ContentStyle = styled('div')(() => ({
  margin: 'auto',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
}));

// ----------------------------------------------------------------------

// button

const Button = (props) => <MuiButton variant="contained" {...props} />;

export default function Profile() {
  const { user, emailIdentities } = useSelector((state) => state.auth);
  const [clientId, setClientId] = useState('XXXXX');
  const [clientSecret, setClientSecret] = useState('XXXXX');
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [details, setDetails] = useState({
    severity: 'success',
    message: '',
  });
  const [emailVerified, setEmailVerified] = useState(false);
  /* useEffect(() => {
    const getProfile = async() => {
      const { data } = await instance.get('/vendor/profile')
      setProfile(data.data)
    }
    if(user.role !== 1)
getProfile()
  },[user]); */

  const verifyEmail = async () => {
    try {
      setLoading(true);
      await instance.post('/mail/verifyEmailIdentity', { emailToBeVerified: user.email });
      setDetails({ severity: 'success', message: 'Email Verified successfully.' });
      setOpen(true);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setDetails({ severity: 'error', message: 'Email Verification failed.' });
      setOpen(true);
      console.log(error.response);
    }
  };

  useEffect(() => {
    if (emailIdentities) {
      const emails = emailIdentities.map((e) => e.email);
      setEmailVerified(emails.includes(user.email));
    }
  }, [emailIdentities]);

  return (
    <Page title="Profile">
      <Container>
        <ContentStyle sx={{ alignItems: 'center' }}>
          <Typography variant="h3" paragraph>
            Details
          </Typography>
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <Card sx={{ width: '100%', p: 2 }}>
                <Typography>
                  <b>Name</b>: {user.name}
                </Typography>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <Typography>
                    <b>Email</b>: {user.email}
                  </Typography>
                  {!emailVerified && user.role !== 1 && (
                    <LoadingButton loading={loading} onClick={verifyEmail}>
                      Verify Email
                    </LoadingButton>
                  )}
                </Stack>
              </Card>
            </Grid>
          </Grid>
          {user.role !== 1 && (
            <Card sx={{ p: 2, width: '100%', mt: 4 }}>
              <h2 style={{ color: 'blue', textAlign: 'center' }}>Credentials</h2>
              <Stack mt={2} sx={{ width: '100%' }} direction="row" justifyContent="space-between">
                <Typography>
                  <b>ClientID</b>
                </Typography>
                <Typography>
                  <b>{clientId}</b>
                </Typography>
                <Button onClick={() => setClientId((state) => (state === 'XXXXX' ? user.client_id : 'XXXXX'))}>
                  {clientId === 'XXXXX' ? 'VIEW' : 'HIDE'}
                </Button>
              </Stack>
              <Stack mt={2} sx={{ width: '100%' }} direction="row" justifyContent="space-between">
                <Typography>
                  <b>Secret Key</b>
                </Typography>
                <Typography>
                  <b>{clientSecret}</b>
                </Typography>
                <Button onClick={() => setClientSecret((state) => (state === 'XXXXX' ? user.client_secrets : 'XXXXX'))}>
                  {clientSecret === 'XXXXX' ? 'VIEW' : 'HIDE'}
                </Button>
              </Stack>
            </Card>
          )}
        </ContentStyle>
      </Container>
      <Message open={open} setOpen={setOpen} details={details} />
    </Page>
  );
}
